"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.afcStimulusInference = void 0;
const plugin_html_multi_response_1 = __importDefault(require("@jspsych-contrib/plugin-html-multi-response"));
// @ts-ignore
const taskSetup_1 = require("../../taskSetup");
const helpers_1 = require("../../shared/helpers");
// @ts-ignore
const trials_1 = require("../../shared/trials");
const taskStore_1 = require("../../../taskStore");
// Previously chosen responses for current practice trial
let practiceResponses = [];
let trialsOfCurrentType = 0;
let keyboardFeedbackHandler;
const incorrectPracticeResponses = [];
const handleStaggeredButtons = async (layoutConfig, pageState) => {
    if (layoutConfig === null || layoutConfig === void 0 ? void 0 : layoutConfig.isStaggered) {
        const parentResponseDiv = document.getElementById('jspsych-html-multi-response-btngroup');
        const stimulusDuration = await pageState.getStimulusDurationMs();
        // Disable the replay button till this animation is finished
        setTimeout(() => {
            pageState.disableReplayBtn();
        }, stimulusDuration + 110);
        for (const jsResponseEl of parentResponseDiv.children) {
            // disable the buttons so that they are not active during the animation
            jsResponseEl.classList.add('lev-staggered-responses', 'lev-staggered-disabled', 'lev-staggered-grayscale', 'lev-staggered-opacity');
        }
    }
};
const getPromptTemplate = (prompt, story, useStimText) => {
    let template = '';
    if (prompt && !useStimText) {
        template += `
      <div class="lev-row-container instruction">
        <p>${prompt}</p>
      </div>
    `;
    }
    if (prompt && useStimText) {
        template += `
      <div class="lev-row-container instruction-no-border">
        <p>${story}</p>
      </div>
      <div class="lev-row-container roar-instruction-question">
        <p>${prompt}</p>
      </div>
    `;
    }
    template += '</div>';
    return template;
};
function getPrompt(layoutConfigMap) {
    var _a;
    // showItem itemIsImage
    const stim = (0, taskStore_1.taskStore)().nextStimulus;
    const t = (0, taskStore_1.taskStore)().translations;
    let itemLayoutConfig = layoutConfigMap === null || layoutConfigMap === void 0 ? void 0 : layoutConfigMap[stim.itemId];
    if (itemLayoutConfig) {
        const { prompt: { enabled: promptEnabled, useStimText: useStimText }, story, stimText: stimulusTextConfig, } = itemLayoutConfig;
        let prompt = '';
        if (promptEnabled && useStimText) {
            prompt = (_a = stimulusTextConfig === null || stimulusTextConfig === void 0 ? void 0 : stimulusTextConfig.value) !== null && _a !== void 0 ? _a : '';
        }
        return getPromptTemplate(prompt, story, useStimText);
    }
}
function getButtonChoices(layoutConfigMap) {
    const stimulus = (0, taskStore_1.taskStore)().nextStimulus;
    const itemLayoutConfig = layoutConfigMap === null || layoutConfigMap === void 0 ? void 0 : layoutConfigMap[stimulus.itemId];
    if (itemLayoutConfig) {
        const { response: { values: buttonChoices }, } = itemLayoutConfig;
        return buttonChoices;
    }
}
function getButtonHtml(layoutConfigMap) {
    const stimulus = (0, taskStore_1.taskStore)().nextStimulus;
    const isPracticeTrial = stimulus.assessmentStage === 'practice_response';
    const itemLayoutConfig = layoutConfigMap === null || layoutConfigMap === void 0 ? void 0 : layoutConfigMap[stimulus.itemId];
    if (itemLayoutConfig) {
        const classList = [...itemLayoutConfig.classOverrides.buttonClassList];
        // TODO: Remove once we have a way to handle practive btns
        if (isPracticeTrial) {
            classList.push('practice-btn');
        }
        return `
      <button class='${classList.join(' ')}'>%choice%</button>
    `;
    }
}
function enableBtns(btnElements) {
    btnElements.forEach((btn) => (btn.disabled = false));
}
function handlePracticeButtonPress(btn, stim, practiceBtns, isKeyBoardResponse, responsevalue, itemConfig) {
    var _a, _b;
    const index = Array.prototype.indexOf.call(practiceBtns, btn);
    const choices = ((_a = itemConfig.response) === null || _a === void 0 ? void 0 : _a.values) || [];
    const choice = choices[index];
    // const choice = btn?.children?.length ? (btn.children[0] as HTMLImageElement).alt : btn.textContent;
    const isCorrectChoice = (choice === null || choice === void 0 ? void 0 : choice.toString()) === ((_b = stim.answer) === null || _b === void 0 ? void 0 : _b.toString());
    if (isCorrectChoice) {
        btn.classList.add('success-shadow');
        setTimeout(() => taskSetup_1.jsPsych.finishTrial({
            response: choice,
            incorrectPracticeResponses,
            button_response: !isKeyBoardResponse ? responsevalue : null,
            keyboard_response: isKeyBoardResponse ? responsevalue : null,
        }), 1000);
    }
    else {
        btn.classList.add('error-shadow');
        // jspysch disables the buttons for some reason, so re-enable them
        setTimeout(() => enableBtns(practiceBtns), 500);
        incorrectPracticeResponses.push(choice);
    }
}
function doOnLoad(layoutConfigMap) {
    const stim = (0, taskStore_1.taskStore)().nextStimulus;
    const itemLayoutConfig = layoutConfigMap === null || layoutConfigMap === void 0 ? void 0 : layoutConfigMap[stim.itemId];
    const playAudioOnLoad = itemLayoutConfig === null || itemLayoutConfig === void 0 ? void 0 : itemLayoutConfig.playAudioOnLoad;
    const pageStateHandler = new helpers_1.PageStateHandler(stim.audioFile, playAudioOnLoad); // this falls to nullAudio
    const isPracticeTrial = stim.assessmentStage === 'practice_response';
    const isInstructionTrial = stim.trialType === 'instructions';
    // Handle the staggered buttons
    handleStaggeredButtons(itemLayoutConfig, pageStateHandler);
    // Setup Sentry Context
    (0, helpers_1.setSentryContext)({
        itemId: stim.itemId,
        taskName: stim.task,
        pageContext: 'afcInference',
    });
    if (isPracticeTrial) {
        const practiceBtns = document.querySelectorAll('.practice-btn');
        practiceBtns.forEach((btn, i) => btn.addEventListener('click', async (e) => {
            handlePracticeButtonPress(btn, stim, practiceBtns, false, i, itemLayoutConfig);
        }));
    }
    if (!isPracticeTrial && !isInstructionTrial) {
        trialsOfCurrentType += 1;
    }
    if (itemLayoutConfig === null || itemLayoutConfig === void 0 ? void 0 : itemLayoutConfig.classOverrides.stimulusContainerClassList.includes('inference-scroll')) {
        const jsPsychContent = document.querySelector('.jspsych-content');
        jsPsychContent === null || jsPsychContent === void 0 ? void 0 : jsPsychContent.classList.add('inference-scroll');
    }
    if (stim.trialType !== 'instructions') {
        const buttonContainer = document.getElementById('jspsych-html-multi-response-btngroup');
        const { buttonLayout } = (0, taskStore_1.taskStore)();
        if (itemLayoutConfig) {
            if (buttonLayout === 'diamond') {
                // have to do it in the runtime
                buttonContainer.classList.add('lev-response-row-diamond-layout');
            }
            else {
                buttonContainer.classList.add(...itemLayoutConfig.classOverrides.buttonContainerClassList);
            }
        }
        // update the trial number
        taskStore_1.taskStore.transact('trialNumSubtask', (oldVal) => oldVal + 1);
        // update total real trials
        if (isPracticeTrial) {
            taskStore_1.taskStore.transact('testTrialCount', (oldVal) => oldVal + 1);
        }
    }
}
function doOnFinish(data, task, layoutConfigMap, validityEvaluator) {
    var _a, _b, _c, _d, _e;
    // note: nextStimulus is actually the current stimulus
    const stimulus = (0, taskStore_1.taskStore)().nextStimulus;
    const itemLayoutConfig = layoutConfigMap === null || layoutConfigMap === void 0 ? void 0 : layoutConfigMap[stimulus.itemId];
    let responseValue = null;
    let target = null;
    let responseIndex = null;
    if ((0, helpers_1.shouldUseClowder)()) {
        (0, helpers_1.checkMaxTimeExceeded)(stimulus.audioFile);
    }
    if (stimulus.trialType !== 'instructions') {
        if (itemLayoutConfig) {
            const { response } = itemLayoutConfig;
            if (!response) {
                throw new Error('Choices not defined in the config');
            }
            responseIndex = data.button_response;
            responseValue = response.values[responseIndex];
            target = response.target;
            data.correct = responseValue === target;
        }
        // check response and record it
        const responseType = 'mouse';
        // Unnormed variants (scoringVersion < 1 or undefined/null)
        if (data.correct) {
            if (stimulus.assessmentStage !== 'practice_response') {
                // practice trials don't count toward total
                taskStore_1.taskStore.transact('totalCorrect', (oldVal) => oldVal + 1);
                (0, taskStore_1.taskStore)('numIncorrect', 0); // reset incorrect trial count
            }
            practiceResponses = [];
        }
        else {
            // Only increase incorrect trials if response is incorrect not a practice trial
            if (stimulus.assessmentStage !== 'practice_response') {
                taskStore_1.taskStore.transact('numIncorrect', (oldVal) => oldVal + 1);
            }
            practiceResponses.push(responseValue);
        }
        if ((0, helpers_1.shouldUseClowder)() && !((_a = stimulus.assessmentStage) === null || _a === void 0 ? void 0 : _a.includes('instruction'))) {
            (0, taskStore_1.taskStore)('previousItem', stimulus);
            (0, taskStore_1.taskStore)('previousAnswer', data.correct ? 1 : 0);
            const stimulusCats = stimulus.zetas.map((zeta) => zeta.cats[0]);
            // Only report response time and accuracy for composite trials
            if (validityEvaluator && !((_b = stimulus.assessmentStage) === null || _b === void 0 ? void 0 : _b.includes('practice')) && stimulusCats.includes('composite')) {
                validityEvaluator.addResponseData(data.rt, data.button_response, data.correct ? 1 : 0);
            }
            const { catsScaled } = helpers_1.CLOWDER_IRT_HYPERPARAMS[task][(0, taskStore_1.taskStore)().scoringVersion];
            const irtEstimates = (0, helpers_1.getIrtEstimates)(taskSetup_1.clowder.theta, taskSetup_1.clowder.seMeasurement, taskSetup_1.scaleTheta, catsScaled);
            (0, taskStore_1.taskStore)('irtEstimates', irtEstimates);
            // Add theta and thetaSe estimates to populate composite.test
            taskSetup_1.jsPsych.data.addDataToLastTrial({
                ...(0, helpers_1.getItemParameters)(stimulus),
                thetaEstimate: (_c = irtEstimates.composite) === null || _c === void 0 ? void 0 : _c.thetaEstimate,
                thetaSE: (_d = irtEstimates.composite) === null || _d === void 0 ? void 0 : _d.thetaSE,
            });
            taskSetup_1.jsPsych.data.write({
                ...(0, helpers_1.getTrialIrtEstimates)(irtEstimates),
            });
        }
        const storyId = stimulus.itemId.split('_')[0];
        taskSetup_1.jsPsych.data.addDataToLastTrial({
            // specific to this trial
            story: stimulus.item,
            item: stimulus.prompt,
            answer: target,
            distractors: stimulus.distractors,
            corpusTrialType: stimulus.trialType,
            responseType,
            responseLocation: responseIndex,
            itemId: stimulus.origItemNum,
            corpusId: (0, taskStore_1.taskStore)().corpus,
            storyId,
        });
        // Adding this seperately or otherwise it will overide
        // the response value added from practice trials
        if (stimulus.assessmentStage !== 'practice_response') {
            taskSetup_1.jsPsych.data.addDataToLastTrial({
                response: responseValue,
            });
        }
    }
    else {
        // instructions
        (0, taskStore_1.taskStore)('numIncorrect', 0); // reset incorrect trial count
        taskSetup_1.jsPsych.data.addDataToLastTrial({
            // false because it's not a real trial
            correct: false,
        });
    }
    // Allow early termination for non-Clowder tasks
    if (!(0, helpers_1.shouldUseClowder)()) {
        if (itemLayoutConfig.inCorrectTrialConfig.onIncorrectTrial === 'skip') {
            (0, helpers_1.setSkipCurrentBlock)(stimulus.trialType);
        }
        else if ((0, taskStore_1.taskStore)().numIncorrect >= (0, taskStore_1.taskStore)().maxIncorrect) {
            (0, trials_1.finishExperiment)();
        }
    }
    (_e = document.querySelector('.jspsych-content')) === null || _e === void 0 ? void 0 : _e.classList.remove('inference-scroll');
}
const afcStimulusInference = ({ responseAllowed, promptAboveButtons, task, layoutConfigMap, validityEvaluator, }) => {
    return {
        type: plugin_html_multi_response_1.default,
        response_allowed_while_playing: responseAllowed,
        data: () => {
            const stim = (0, taskStore_1.taskStore)().nextStimulus;
            let isPracticeTrial = stim.assessmentStage === 'practice_response';
            return {
                // not camelCase because firekit
                save_trial: true,
                assessment_stage: stim.assessmentStage,
                // not for firekit
                isPracticeTrial: isPracticeTrial,
            };
        },
        stimulus: () => getPrompt(layoutConfigMap),
        prompt_above_buttons: promptAboveButtons,
        button_choices: () => getButtonChoices(layoutConfigMap),
        button_html: () => getButtonHtml(layoutConfigMap),
        on_load: () => doOnLoad(layoutConfigMap),
        on_finish: (data) => doOnFinish(data, task, layoutConfigMap, validityEvaluator),
        response_ends_trial: () => ((0, taskStore_1.taskStore)().nextStimulus.assessmentStage === 'practice_response' ? false : true),
    };
};
exports.afcStimulusInference = afcStimulusInference;
